"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var Error = /** @class */ (function (_super) {
    __extends(Error, _super);
    function Error() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Error.prototype.render = function () {
        var _a = this.props.section, settings = _a.settings, blocks = _a.blocks;
        var horizontal = settings.horizontal ? settings.horizontal.toLowerCase().replace("left", "start").replace("right", "end") : "center";
        return (React.createElement(Snippets.Container, { width: settings.fullwidth ? "full" : "xl", className: (settings.verticalspacing ? "py-7-2 md:py-12" : "") + " text-center" },
            React.createElement("div", { className: "relative" },
                settings.image ? (React.createElement("div", { className: "md:absolute pin mx-auto" },
                    React.createElement(Snippets.Image, { className: "bg-cover bg-center absolute pin hidden md:block", src: settings.image }),
                    React.createElement(Snippets.Image, { bgNatural: true, className: "block md:hidden", src: settings.imagemobile ? settings.imagemobile : settings.image }))) : null,
                settings.title || settings.button || settings.content ? (React.createElement("div", { className: "py-5 md:relative absolute mx-auto pin z-10 max-w-xl mlg:px-11 md:px-3 px-6" },
                    React.createElement("div", { className: " md:flex-row flex-col w-full mlg:px-11 md:px-3 px-0 flex h-full items-center justify-" + horizontal + " text-" + settings.alignment },
                        React.createElement("div", { className: "lg:w-1/4 md:w-1/2 w-full text-" + settings.foreground },
                            React.createElement(Snippets.Heading, { size: "h2", tag: "h1", className: "font-extrabold" }, settings.title),
                            settings.content ? (React.createElement(Snippets.RichText, { className: "", size: "" }, settings.content)) : null,
                            React.createElement(Snippets.Button, { className: "mt-2-2 h-4-4 px-2-4", style: "chevron", reverse: true, href: settings.url, title: settings.button }, settings.button))))) : null)));
    };
    return Error;
}(React.PureComponent));
exports.Error = Error;
